/**
 * Builds the single-line label shown for a subsidiary-page row in the Sort modal.
 * Combines the category name and the content-type label, e.g. "Bank — Subsidiary Hero".
 * Any empty/undefined part is omitted so the label degrades gracefully.
 */
export const buildSortLabel = (categoryName?: string, contentTypeLabel?: string): string =>
  [categoryName, contentTypeLabel].filter(Boolean).join(' — ')
